Ext.define('SA.data.UserDatasets', {
    extend: 'Ext.util.Observable',

    singleton: true,

    async delete(id) {
        await SA.data.UserAttributes.removeForDataset(id);

        await SA.Ajax.request({
            method: 'delete',
            resource: 'user/data',
            data: {datasetSeries: id}
        });

        this.data = this.data.filter(item => item.id !== id);
        this.fireEvent('delete');
    },

    get(id) {
        return this.data.find(item => item.id === id);
    },

    getAll() {
        return this.data;
    },

    getIds() {
        return this.data.map(({id}) => id);
    },

    getDatasetsForCountry(country) {
        return this.data.filter(item => item.country === country);
    },

    getLatestEditionFor(id) {
        return this.get(id).latestEdition;
    },

    getModel({id, name, country: countryCode}) {
        var vendorName = SA.data.Vendors.getImportsVendorName(),
            anyAttribute = SA.data.UserAttributes.getForDataset(id)[0],
            edition = anyAttribute.year,
            censusReleaseYear = anyAttribute.censusRelease;

        return new SA.model.ImportDataset({id, name, censusReleaseYear, edition, vendorName, countryCode});
    },

    getModels() {
        return this.data.map(dataset => this.getModel(dataset));
    },

    getName(id) {
        return this.data.find(item => item.id === id).name;
    },

    getNames() {
        return this.data.map(({name}) => name);
    },

    hasDatasets() {
        return !!this.data.length;
    },

    hasDatasetsForCountry(country) {
        return !!this.getDatasetsForCountry(country).length;
    },

    isDuplicateName(name) {
        var names = this.getNames().map(name => name.toLowerCase());

        return names.includes(name.trim().toLowerCase());
    },

    isUserDataset(datasetId) {
        return this.getIds().some(id => id === datasetId);
    },

    async loadAll() {
        var response = await SA.Ajax.request({resource: 'user/data'}),
            sortByName = (a, b) => SA.data.Sort.titleText(a.name, b.name);

        this.data = response.sort(sortByName).map(mapServerItem);

        function mapServerItem(item) {
            var {datasetSeries: id, geographicUnits, imported, name} = item,
                country = SA.data.GeographicUnits.countryFor(geographicUnits[0]);

            return {id, name, country, geographicUnits, imported};
        }
    },

    rename(id, name) {
        this.get(id).name = name;

        SA.data.UserAttributes.updateDatasetName(id, name);

        SA.Ajax.request({
            method: 'rename',
            resource: 'user/data',

            data: {
                datasetSeries: id,
                name
            }
        });

        this.fireEvent('rename');
    }
});
